import styled from 'styled-components';

export const Info = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: #556692;
`;
